module.exports = __webpack_public_path__ + "images/notifications/performance_pulse.png";